export default __webpack_public_path__ + "static/media/Nomessages.f3f414d9.svg";